"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Parse style value to string.
 * Base on code from https://github.com/OpenJSX/jsx-to-html
 * @see https://github.com/OpenJSX/jsx-to-html/blob/master/index.js#L80
 */
function parseStyles(style) {
    if (typeof style === 'string') {
        return style;
    }
    var value = '';
    for (var key in style) {
        if (!Object.prototype.hasOwnProperty.call(style, key) ||
            style[key] === null ||
            style[key] === undefined) {
            continue;
        }
        var val = style[key];
        key = key.replace(/[A-Z]/g, function (m) {
            return '-' + m.toLowerCase();
        });
        if (key.search(/moz-|webkit-|o-|ms-/) === 0) {
            key = '-' + key;
        }
        value += (value ? ' ' : '') + key + ': ' + val + ';';
    }
    return value;
}
exports.parseStyles = parseStyles;
